import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";

export const PasswordInput = ({ className = "", ...props }) => {
  const [show, setShow] = useState(false);
  const id = props["data-testid"] || "password";
  return (
    <div className="relative">
      <Input {...props} type={show ? "text" : "password"} className={`pr-10 ${className}`} />
      <button type="button" onClick={() => setShow((v) => !v)} tabIndex={-1}
        className="absolute inset-y-0 right-0 grid w-10 place-items-center text-slate-400 transition-colors duration-150 hover:text-plum-700"
        aria-label={show ? "Hide password" : "Show password"} data-testid={`${id}-toggle`}>
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
};
